// extracted by mini-css-extract-plugin
export var section = "_4s-1";
export var topNav = "_4s-0";